import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MaterialDesignContent, SnackbarProvider } from 'notistack'
import "./Assets/css/icons.css";
import "./Assets/css/global.css";
import "./Assets/css/pages.css";
import "./index.scss";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LazyMotion, domMax } from 'framer-motion';
import styled from 'styled-components';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/900.css';


const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: '#ebb55b',
    color: '#004878'

  },
  '&.notistack-MuiContent-error': {
    backgroundColor: '#ebb55b',
    color: '#004878'
  },
  '&.notistack-MuiContent-warning': {
    backgroundColor: '#ebb55b',
    color: '#004878'
  },
}));

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LazyMotion features={domMax}>
    <QueryClientProvider client={queryClient}>
      <SnackbarProvider
        Components={{
          success: StyledMaterialDesignContent,
          error: StyledMaterialDesignContent,
          warning: StyledMaterialDesignContent
        }}
        style={{ marginBottom: '50px' }}
      >
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </SnackbarProvider>
    </QueryClientProvider>
  </LazyMotion>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
